/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import jwt_decode from 'jwt-decode';
import { Button, Card, Container } from '@mui/material';
import successImage from '../assets/images/success.png';
import failImage from '../assets/images/fail.png';
import cancelImage from '../assets/images/cancel.png';
import incompleteImage from '../assets/images/incomplete.png';
import pendingImage from '../assets/images/time.logo.png';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

function TransactionResultEDonation({ refID, tokens }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState('success');
  const [token, setToken] = useState('');
  const [tokened, setTokened] = useState('');
  const [urlMerchant, setUrlMerchant] = useState('');
  const [formMerchant, setFormMerchant] = useState('');
  const [bodyMerchant, setBodyMerchant] = useState({});
  const [tagMerchant, setTagMerchant] = useState('');
  const [urlPDF, setUrlPDF] = useState('');

  const location = useLocation();
  const cancelFormRef = useRef(null);
  const merchantFormRef = useRef(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const statusParam = queryParams.get('status');
    const tokenParam = queryParams.get('token');
    const authorization = queryParams.get('authorization');
    const urlPDFParam = queryParams.get('urlPDF');

    if (statusParam) {
      setStatus(statusParam);
      if (tokenParam) {
        const decoded = jwt_decode(tokenParam);
        setUrlMerchant(decoded.url);
        setBodyMerchant(decoded.webhook.json);
        setTagMerchant(decoded.webhook.tag);
      }
    }

    if (authorization) {
      setStatus('paid');
      setToken(authorization);
    }

    if (urlPDFParam) {
      setUrlPDF(urlPDFParam);
    }
  }, [location.search]);

  useEffect(() => {
    if ((status === 'paid' || status === 'success') && urlPDF) {
      autoDownloadPDF();
    }
  }, [status, urlPDF]);

  const images = {
    success: successImage,
    fail: failImage,
    cancel: cancelImage,
    incomplete: incompleteImage,
    pending: pendingImage,
  };

  const backgroundColors = {
    success: '#007CC2',
    // paid: '#b9f6ca',
    fail: '#ff8a80',
    cancel: '#ffd180',
    incomplete: '#ea80fc',
    pending: '#fef99d',
    default: '#ffffff',
  };

  const autoDownloadPDF = () => {
    if (urlPDF) {
      window.location.href = urlPDF;
    }
  };

  const cancel = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIHOST}/cancelpayment`,
        {
          method: 'POST',
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ status: 'Success' }),
        },
      );
      const data = await response.json();
      setUrlMerchant(data.tagUrl);
      setFormMerchant(data.tagInput);

      setTimeout(() => {
        if (cancelFormRef.current) {
          cancelFormRef.current.submit();
        }
      }, 750);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleBack = () => {
    navigate('/donation');
  };

  const toMerchant = () => {
    try {
      const formData = new FormData();
      Object.keys(bodyMerchant).forEach((key) => {
        formData.append(key, bodyMerchant[key]);
      });

      setUrlMerchant(urlMerchant);
      setFormMerchant(tagMerchant);

      setTimeout(() => {
        if (merchantFormRef.current) {
          merchantFormRef.current.submit();
        }
      }, 750);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div
      style={{
        backgroundColor: backgroundColors[status] || backgroundColors.default,
        minHeight: '100vh',
      }}
    >
      <Container fluid>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Card
            className="card"
            style={{
              width: '100%',
              maxWidth: '750px',
              borderRadius: '20px',
              padding: '50px',
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  marginTop: '40px',
                }}
              >
                <div>
                  {status === 'success' || status === 'paid' ? (
                    <img
                      src={images.success}
                      style={{ marginBottom: '25px', width: '100px' }}
                      alt="Success"
                    />
                  ) : null}
                  {status === 'fail' ? (
                    <img
                      src={images.fail}
                      style={{ marginBottom: '25px', width: '100px' }}
                      alt="Fail"
                    />
                  ) : null}
                  {status === 'cancel' ? (
                    <img
                      src={images.cancel}
                      style={{ marginBottom: '25px', width: '100px' }}
                      alt="Cancel"
                    />
                  ) : null}
                  {status === 'incomplete' ? (
                    <img
                      src={images.incomplete}
                      style={{ marginBottom: '25px', width: '100px' }}
                      alt="Incomplete"
                    />
                  ) : null}
                  {status === 'pending' ? (
                    <img
                      src={images.pending}
                      style={{ marginBottom: '25px', width: '100px' }}
                      alt="Pending"
                    />
                  ) : null}
                </div>
              </div>

              <div
                style={{
                  textTransform: 'uppercase',
                  color: '#55585b',
                  fontSize: '20px',
                  fontWeight: '500',
                  marginBottom: '5px',
                }}
              >
                {status === 'paid' ? 'Your payment was successful' : null}
                {status === 'success' ? 'การชำระเงินของคุณสำเร็จแล้ว' : null}
                {status === 'cancel' ? 'Your payment is cancelled' : null}
                {status === 'fail' ? 'Your payment is failed' : null}
                {status === 'pending' ? 'Your payment is on pending' : null}
                {status === 'incomplete' ? 'Your payment is incomplete' : null}
              </div>
              <div
                style={{
                  color: '#959a9e',
                  fontSize: '16px',
                  fontWeight: '400',
                  marginTop: '15px',
                  marginBottom: '30px',
                }}
              >
                ขอบคุณที่ใช้บริการ INET e-Payment หากต้องการข้อมูลเพิ่มเติม
                กรุณาติดต่อผู้ให้บริการ
              </div>

              {(status === 'paid' || status === 'success') && urlPDF ? (
                <div
                  style={{
                    marginBottom: '30px',
                  }}
                >
                  <a
                    href={urlPDF}
                    download
                    style={{
                      color: '#959a9e',
                      fontSize: '16px',
                      fontWeight: '400',
                      textDecoration: 'underline',
                    }}
                  >
                    Download E-Tax Receipt Here.
                  </a>
                </div>
              ) : null}

              <Button
                style={{ fontSize: '13px', marginTop: '70px' }}
                variant="outlined"
                color="success"
                onClick={handleBack}
              >
                กลับไปที่หน้าสร้างรายการชำระเงิน
              </Button>

              {token || tokened ? (
                <Button
                  style={{ fontSize: '13px', marginTop: '70px' }}
                  variant="outlined"
                  color="success"
                  onClick={token ? cancel : toMerchant}
                >
                  Back to Merchant
                </Button>
              ) : null}

              <form
                id="cancelForm"
                ref={cancelFormRef}
                action={urlMerchant}
                method="POST"
              >
                <span dangerouslySetInnerHTML={{ __html: formMerchant }} />
              </form>
              <form
                id="merchantForm"
                ref={merchantFormRef}
                action={urlMerchant}
                method="POST"
              >
                <span dangerouslySetInnerHTML={{ __html: formMerchant }} />
              </form>
            </div>
          </Card>
        </div>
      </Container>
    </div>
  );
}

export default TransactionResultEDonation;
